export default function _OverloadYield(value, kind) {
  this.v = value, this.k = kind;
}